import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-467b5936")

_pushScopeId("data-v-467b5936")
const _hoisted_1 = {
  id: "startOfSkills",
  class: "flex flex--width flex--v flex--valign-c flex--gap-30"
}
const _hoisted_2 = {
  key: 0,
  class: "slider-legend flex flex--width flex--v flex--valign-e flex--gap-5"
}
const _hoisted_3 = { class: "slider-legend-entry flex flex--valign-c flex--gap-20" }
const _hoisted_4 = { class: "text text--size-18 text--accent-gray-b text--medium text--right" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "slider-legend-blob slider-legend-blob--primary" }, null, -1)
const _hoisted_6 = { class: "slider-legend-entry flex flex--valign-c flex--gap-20" }
const _hoisted_7 = { class: "text text--size-18 text--accent-gray-b text--medium text--right" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "slider-legend-blob slider-legend-blob--secondary" }, null, -1)
const _hoisted_9 = { class: "slider-legend-entry flex flex--valign-c flex--gap-20" }
const _hoisted_10 = { class: "text text--size-18 text--accent-gray-b text--medium text--right" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex--v flex--valign-c flex--width flex--gap-15"
}
const _hoisted_12 = { class: "carousel-bottom-buttons flex flex--valign-c flex--gap-20" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CarouselButton = _resolveComponent("CarouselButton")
  const _component_Icon = _resolveComponent("Icon")
  const _component_CompanySkill = _resolveComponent("CompanySkill")
  const _component_TransitionHeight = _resolveComponent("TransitionHeight")
  const _component_GenericButton = _resolveComponent("GenericButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_CarouselButton, {
      ref: "refCarouselButton",
      class: "carousel-button",
      "selected-index": _ctx.selectedIndex,
      values: _ctx.qualificationGroups,
      onChangeValue: _ctx.changeValue
    }, {
      title: _withId(({ selectedItem }) => [
        _createTextVNode(_toDisplayString(selectedItem ? _ctx.$trans("qualifications." + selectedItem.name) + ` ( ${_ctx.selectedIndex + 1} / ${_ctx.qualificationGroups.length} )` : "No item"), 1)
      ]),
      _: 1
    }, 8, ["selected-index", "values", "onChangeValue"]),
    (_ctx.isCompany)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$trans("qualifications.your_choice")), 1),
            _hoisted_5
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$trans("qualifications.requirements")), 1),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$trans("qualifications.important")), 1),
            _createVNode(_component_Icon, {
              class: "slider-legend-icon",
              identifier: 'djf_update_star'
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentGroup)
      ? (_openBlock(), _createBlock(_component_TransitionHeight, {
          key: 1,
          class: "full-width"
        }, {
          default: _withId(() => [
            (_ctx.currentGroup)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentGroup.qualifications, (qualification, idx) => {
                    return (_openBlock(), _createBlock(_component_CompanySkill, {
                      key: idx,
                      qualification: qualification,
                      "qualification-value": _ctx.getQualificationValueById(qualification.id),
                      "company-requirement": _ctx.getCompanyRequirementForQualificationId(qualification.id),
                      company: _ctx.isCompany,
                      create: _ctx.create,
                      onQualificationValueChanged: (val) => _ctx.$emit('qualificationValueChanged', qualification.id, val, false),
                      onCreateValueChanged: (val, important) => _ctx.$emit('createValueChanged', qualification.id, val, important)
                    }, null, 8, ["qualification", "qualification-value", "company-requirement", "company", "create", "onQualificationValueChanged", "onCreateValueChanged"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_GenericButton, {
        class: "carousel-bottom-button",
        title: _ctx.$trans('main.button_back'),
        circular: true,
        simple: true,
        uppercase: true,
        disabled: (_ctx.isCompany || _ctx.create) && _ctx.selectedIndex <= 0,
        onClick: _ctx.clickPrevCarousel
      }, null, 8, ["title", "disabled", "onClick"]),
      _createVNode(_component_GenericButton, {
        class: "carousel-bottom-button",
        title: _ctx.selectedIndex >= _ctx.qualificationGroups.length - 1 && !_ctx.isCompany && !_ctx.create ? _ctx.$trans('main.button_done') : _ctx.$trans('main.button_continue'),
        circular: true,
        uppercase: true,
        disabled: (_ctx.isCompany || _ctx.create) && _ctx.selectedIndex >= _ctx.qualificationGroups.length - 1,
        onClick: _ctx.clickNextCarousel
      }, null, 8, ["title", "disabled", "onClick"])
    ])
  ]))
})